<template>
  <div class="journeyApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="meheader">
      <div class="headMe">
        <img :src="userData.avatar" />
        <div class="right">
          <h2>{{userData.username}}</h2>
          <p>加入时间:{{userData.createtime}}</p>
        </div>
      </div>
      <ul>
        <li>
          <h3>{{setTotal}}</h3>
          <div>打卡总数</div>
        </li>
        <li>
          <h3>{{setTotal <= 0 ? 0 : Math.floor(setTotal / setConponCode[0].sign)}}</h3>
          <div>奖励次数</div>
        </li>
        <li>
          <h3>{{dayTotal}}</h3>
          <div>当天打卡</div>
        </li>
        <li>
          <h3>{{dayWeek}}</h3>
          <div>本周打卡</div>
        </li>
      </ul>
    </div>
    <dl>
      <dt><img src="../../assets/images/lc.png"/>我的打卡历程 
        <a v-if="state == 1" @click="signCode"><em class="el-icon-plus"></em>打卡</a>
        <a @click="$router.push('movies')" style="background:none;color:#0059D6;text-align:right;" v-if="state != 1">看电影<em class="el-icon-arrow-right"></em></a>
      </dt>
      <dd style="padding-top:20px" v-if="setTotal > 0">
        <el-timeline>
          <el-timeline-item v-for="(vo,k) in setConponCode" icon="el-icon-success" type="primary" color="#fff" size="large">
            <div style="color:#333;font-size:15px"><img class="avatar" :src="userData.avatar" />{{userData.username}}<font style="float:right;font-size:13px;color:#808080">{{vo.create_time}}</font></div>
            <div class="sign"><em class="el-icon-circle-check"></em> 已签到</div>
            <div style="background: #F2F4F7;border-radius: 5px;padding:10px;font-size:15px;color:#333">{{vo.content}}</div>
            <div @click="$router.push('movies')" class="jl" v-if="vo.rank % vo.sign == 0">恭喜您，签到满{{vo.sign}}次奖励价值30元电影优惠券一张，快去看电影吧<a>看电影<em class="el-icon-arrow-right"></em></a></div>
          </el-timeline-item>
        </el-timeline>
      </dd>
    </dl>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        setConponCode:[],
        setTotal:0,
        dayTotal:0,
        dayWeek:0,
        state:0
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/journey');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
        this.getCouponCode();
      }

    },
    mounted() {
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getCouponCode:function(){
        var that = this;
        that.fullscreenLoading = true;
        var jwt = JSON.parse(localStorage.getItem('userjwt'));
        var code = that.$route.query.s;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/getCouponCode',
          data:{
            user_id:jwt.id,
            str:that.$route.query.str
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.setConponCode = data.data.rs;
              that.setTotal = data.data.total;
              that.dayTotal = data.data.dayTotal;
              that.dayWeek = data.data.dayWeek;
              that.state = data.data.state;
              }else{
                that.$alert(data.message, '提示');
              }
            
            that.fullscreenLoading = false;
          }
        })
      },
      signCode:function(){
        var that = this;
        that.fullscreenLoading = true;
        var jwt = JSON.parse(localStorage.getItem('userjwt'));
        var code = that.$route.query.s;
        var content = that.$route.query.content;
        var coupon_id = that.$route.query.couponId;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/couponCode',
          data:{
            user_id:jwt.id,
            str:that.$route.query.str
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.$alert('打卡成功!', '提示',{
                confirmButtonText: '确定',
                callback: action => {
                  that.getCouponCode();
                }
              });
            }else{
              that.$alert(data.message, '提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.getCouponCode();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .journeyApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }

  .journeyApp .meheader{
    background: linear-gradient(90deg, #61BEFF, #4F7CFF);
  }
  .journeyApp .headMe{
    width:92%;
    margin:0 auto;
    padding:15px 0;
  }
  .journeyApp .headMe:after,.journeyApp ul:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .journeyApp .headMe img{
    width:60px;
    border-radius:100%;
    float:left;
  }
  .journeyApp .headMe .right{
    float:left;
    width:75%;
    margin-left:3%;
  }
  .journeyApp .headMe .right h2{
    font-size:18px;
    padding:7px 0 5px 0;
    color:#fff
  }
  .journeyApp .headMe .right p{
    font-size:15px;
    color:#555;
    color:#fff
  }
  .journeyApp .meheader ul{
    clear:both;
    padding:0px 0 20px 0;
    width:100%
  }
  .journeyApp .meheader ul li{
    float:left;
    width:25%;
    position:relative;
  }
  .journeyApp .meheader ul li:after{
    position:absolute;
    content:'';
    width:1px;
    height:30px;
    background:#61BEFF;
    right:0;
    top:50%;
    transform: translateY(-50%);
  }
  .journeyApp .meheader ul li:last-child:after{
    background:#4F7CFF;
  }
  .journeyApp .meheader ul li h3{
    text-align:center;
    font-size:20px;
    color:#fff
  }
  .journeyApp .meheader ul li div{
    text-align:center;
    font-size:14px;
    color:#666;
    padding-top:3px;
    color:#fff
  }
  .journeyApp dl{
    background:#fff;
    width:100%;
    margin:0 auto 15px auto;
  }
  .journeyApp dl dt{
    border-bottom:solid 1px #EAECED;
    width:92%;
    margin:0 auto;
    padding:0 4%;
    font-weight: bold;
    font-size:16px;
    margin-bottom:8px;
    background: linear-gradient( 180deg, #FFF6E3 0%, #FFFFFF 100%);
    height:55px;
    line-height:55px
  }
  .journeyApp dl dt img{
    float:left;
    width:21px;
    margin:17px 5px 0 0
  }
  .journeyApp dl dt a{
    float:right;
    height: 30px;
    width: 64px;
    background: #0059D6;
    border-radius: 30px;
    text-align:center;
    line-height: 32px;
    color:#fff;
    font-weight:normal;
    font-size:13px;
    margin-top:12.5px
  }
  .journeyApp dl dd{
    width:92%;
    margin:0 auto;
    padding:10px 0;
    position: relative;
  }
  .journeyApp dl dd:after{
    display:block;
    clear:both;
    content:"";
    overflow:hidden;
    height:0;
  }
  .journeyApp dl .el-icon-success{
    font-size:18px;
    color:#00b042;
  }
  .journeyApp dl dd img{
    width:16px;
    height:16px;
    border-radius:50%;
    float:left;
    margin:2px 2px 0 0
  }
  .journeyApp dl dd .sign{
    font-size:14px;
    color:#00b042;
    padding:10px 0 10px 2px
  }
  .journeyApp dl dd .jl{
    font-size:14px;
    color:#E34D59;
    padding:10px 0 0 0
  }
  .journeyApp dl dd .jl a{
    background:#E34D59;
    color:#fff;
    border-radius:6px;
    font-size:12px;
    display:block;
    height: 30px;
    width: 64px;
    text-align:center;
    line-height: 30px;
    margin-top:8px
  }
</style>